module.exports = __webpack_public_path__ + "img/portrait-056.3c2a8a2a.jpg";